import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/router/routes';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="max-w-sm text-center">
        <div
          className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full"
          style={{ backgroundColor: 'var(--status-error-bg)' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-8 w-8"
            style={{ color: 'var(--status-error-text)' }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
        </div>
        <h1 className="mb-2 text-xl font-bold" style={{ color: 'var(--nwm-navy-900)' }}>
          Access Denied
        </h1>
        <p className="mb-6 text-sm text-gray-500">
          You do not have permission to access this resource. Contact your platform administrator if you believe this is an error.
        </p>
        <button
          type="button"
          className="rounded px-5 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: 'var(--nwm-navy-700)' }}
          onClick={() => void navigate(ROUTES.DASHBOARD)}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
